<template>
    <OmniCheckboxes draggable hide-checkboxes prepend-numbers class="list" :options="options" v-model="internalValue" :disabled="disabled" />
</template>

<script>

export default {
    name: 'OmniDraggableList',
    
    props: {
        value:   { required: true },
        options: { required: true }, // e.g. [{ text: "A", value: "a" }, { text: "B", value: "b" }, { text: "C", value: "c" } ]
        disabled:{ required: false, default: false },
    },

    mounted() {
        /**
         * For OmniCheckboxes, if the component is solely used for sorting values,
         * it needs to assume that all values are selected / "checked".
         * We do this programmatically by initializing the values of the v-model here.
         */

        this.internalValue = structuredClone(this.value)
        const availableValues = this.options.map((option) => option.value); // e.g. ['a', 'b', 'c']

        // Keep current order of internalValue, but add missing from availableValues, i.e. ['b', 'a', 'c']
        this.internalValue = availableValues.reduce((acc, value) => {
            if (!acc.includes(value)) {
                acc.push(value);
            }
            return acc;
        }, structuredClone(this.internalValue));
    },

    data() {
        return {
            internalValue: null,
        }
    },

    watch: {
        internalValue: {
            deep: true,
            handler() {
                this.$emit('input', this.internalValue)
            },
        }
    }
}
</script>
